// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "CreditLinkageQuestions__textCenter__7g2tR";
export const creditLinkageQuestions = "CreditLinkageQuestions__creditLinkageQuestions__TsZYs";
export const dotsPager = "CreditLinkageQuestions__dotsPager__m0bIj";
export const dot = "CreditLinkageQuestions__dot__+zZJ6";
export const dotActive = "CreditLinkageQuestions__dotActive__553iw";
export const creditQuestion = "CreditLinkageQuestions__creditQuestion__Mo1G+";
export const questionTitle = "CreditLinkageQuestions__questionTitle__j4VTM";
export const answers = "CreditLinkageQuestions__answers__QNjf4";
export const answer = "CreditLinkageQuestions__answer__luxHF";